// base
import Main from "./Main";
import Blocks from "./Blocks";
import BlocksDetail from "./Blocks/BlocksDetail";
import Transactions from "./Transactions";
import TransactionsDetail from "./Transactions/TransactionsDetail";
import Account from "./Account";
import Contract from "./Contract";
import Ranking from "./Ranking";
import TransactionList from "./TransactionList";
import ContractList from "./Contract/ContractList";
import TokenTransactionList from "./TransactionList/TokenTransactionList";

const routes = [
  {
    path: "/",
    component: Main,
  },
  {
    path: "/blocks",
    component: Blocks,
  },
  {
    path: "/blocks/detail/:number",
    component: BlocksDetail,
  },
  {
    path: "/transactions/:page",
    component: Transactions,
  },
  {
    path: "/transactions/detail",
    component: TransactionsDetail,
  },
  {
    path: "/transactions/detail/:hash",
    component: TransactionsDetail,
  },
  {
    path: "/transaction/:hash",
    component: TransactionsDetail,
  },
  {
    path: "/transactionList",
    component: TransactionList,
  },
  {
    path: "/tx/:hash",
    component: TransactionsDetail,
  },
  {
    path: "/account/:address",
    component: Account,
  },
  {
    path: "/address/:address",
    component: Account,
  },
  {
    path: "/transactions/account/:address",
    component: Account,
  },
  {
    path: "/transactions/account/:address/:pagenum",
    component: Account,
  },
  {
    path: "/contract/:address",
    component: Contract,
  },
  {
    path: "/ranking",
    component: Ranking,
  },
  {
    path: "/contract/contractList/:type",
    component: ContractList,
  },
  {
    path: "/contract/transactionList/:type",
    component: TokenTransactionList,
  },
];

export default routes;
